import React, { FC } from 'react';
import { SettingsCardsPageSkeleton, SettingsFormPageSkeleton, SettingsTablePageSkeleton } from '../settingsSkeleton';

export const StandaloneSitesPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
export const StandaloneSiteDetailPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
export const StandaloneSiteCollectionPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
export const StandaloneSiteThemeSettingsPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
